import { useEffect, useState } from 'react';
import { getIsraelNow } from '../utils/israelTime';

/** The current Israel date and time ("YYYY-MM-DD", "HH:mm"), refreshed every minute. */
export function useIsraelNow(): { date: string; time: string } {
  const [now, setNow] = useState(() => getIsraelNow());

  useEffect(() => {
    const interval = setInterval(() => {
      const next = getIsraelNow();
      setNow((prev) => (prev.date === next.date && prev.time === next.time ? prev : next));
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  return now;
}
